import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../Button/Button';
import styles from './RecoveryUsername.module.scss';
import { useTheme } from '../../../../../ThemeContext';
// import { ic_username_recovery } from "@/shared/assets/assets"; // Need to find equivalent asset or use an icon

export const RecoveryUsername = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation('account');
  const { universalStyles } = useTheme();

  return (
    <div className={styles.logoutModalContainer}>
      <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="29.0014" cy="28.9881" rx="25.7045" ry="25.6927" fill="#E32652" />
        <ellipse cx="29" cy="28.9866" rx="29" ry="28.9866" fill="#22C55E" />
        <path d="M17 30.186L24.1588 37.2843C24.5486 37.6708 25.1772 37.6708 25.567 37.2843L42 20.9902" stroke="white" strokeWidth="4" strokeLinecap="round" />
      </svg>
      <div className={styles.content}>
        <p className={styles.logoutTitle} style={universalStyles.primaryTextColor}>
          {t('reset.check_your_email')}
        </p>
        <p className={styles.logoutSubtitle}>
          {t('reset.username_sent_to_email')}
        </p>
      </div>
      <div className={styles.logoutButtonGroup}>
        <Button
          label={t('reset.okay')}
          onClick={onClose}
          color="primary"
          variant="contained"
          fullWidth
        />
      </div>
    </div>
  );
};
